<template>
  <div>
    <div class="page flex ai-s">
      <div class="leftBox">
        <div v-if="detailInfo != null">
          <div class="prediction">
            <div class="predictionBox">
              <div class="head flex flex-pack-justify flex-align-center">
                <div class="flex flex-align-center">
                  <i class="poissonIcon" />
                  <div class="title">Poisson Predicted Goals</div>
                </div>
                <i class="queryIcon" @click="showPopup()"/>
              </div>
              <ul class="resultsBox flex">
                <li v-for="(item,index) in detailInfo.goalModel.goalTopOptions" :key="index">
                  <div class="score flex flex-align-center" :class="isHit(item.isHit)">{{item.score == '1d' ? 'Others' : item.score + (item.score > 1 ? ' goals' : ' goal')}} <i v-if="item.isHit == 1" class="active"/></div>
                  <div class="percentage">{{ item.value }}%</div>
                  <div class="odds">odds {{ item.odds == 0 ? '-' : item.odds }}</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="logged" style="clear: both" v-if="isLogin == true || match.state == 4">
            <!-- 进球概率分布 -->
            <div class="goalProbability" v-if="detailInfo.goalModel.hasOwnProperty('goalTotalOptions')">
              <div class="title">Goal Scoring Probability</div>
              <ul class="goalProbabilityBox flex flex-warp">
                <li v-for="(item,index) in detailInfo.goalModel.goalTotalOptions" :key="index">
                  <div class="topBox">{{ item.score }} Goal{{ item.score == 0 || item.score == 1 ? '' : 's' }}</div>
                  <div class="bottomBox">
                    <div class="percentage">{{ item.value }}%</div>
                    <div class="odds">{{ item.odds != 0 ? item.odds : '-' }}</div>
                  </div>
                </li>
              </ul>
            </div>

            <!-- 两队数据对比 -->
            <div class="twoTeamscontrast">
              <div class="flex flex-pack-justify flex-align-center">
                <div class="title">Home vs Away Statistics Comparison</div>
                <div class="flex">
                  <span class="home">Home</span>
                  <span class="away">Away</span>
                </div>
              </div>
              <div class="twoTeamscontrastBox">
                <div class="radarEchart" ref="radarEchart" style="width: 100%;"></div>
                <div class="tip">Note: The data refers to home/away statistics, where the home team's data is shown when playing at home, and the away team's data is shown when playing away.</div>
              </div>
            </div>

            <!-- 过往交锋进球数走势 -->
            <div class="pastConfrontationGoals" v-if="detailInfo.goalModel.goalsLastLog.length>0">
              <div class="flex flex-pack-justify flex-align-center">
                <div class="title">Head-to-Head Goal Trends</div>
                <div class="homeAndAway" :class="goals_isChecked == true ? 'active' : ''" @click="goalsHomeAndAway()">Home/Away</div>
              </div>
              <div class="pastConfrontationGoalsBox">
                <div class="container">
                  <div v-if="((goals_isChecked == false && detailInfo.goalModel.goalsLastLog.length > 0) || (goals_isChecked == true && detailInfo.goalModel.goalsSameLastLog.length > 0))" ref="lineEchart"></div>
                  <div v-else class="nodata">
                    <img src="../../../assets/images/nodata.png">
                    No data
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 未登录 -->
          <div class="noLogin" v-if="isLogin == false && match.state != 4">
            <!-- <img src="../../../assets/images/noLogin_Bg1.png"> -->
            <div class="noLoginBox">
              <i class="noLoginIcon"></i>
              <p>Log in to view the content.</p>
              <div class="btn" @click="onChangePop({loginShow:true, loginInfoShow:false})">Log in Now</div>
            </div>
          </div>
        </div>
        <div v-else class="noData">
          <div><img src="../../../assets/images/nodata.png" /></div>
          <div class="title">No data</div>
        </div>
      </div>

      <div class="rightBox flex1">
        <div class="title">Additional Matches</div>
        <ul class="list">
          <li v-for="(item,index) in relateMatch" :key="index" @click="changeMatch(item)">
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.homeTeam.fullName }}</div>
            </div>
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.awayTeam.fullName }}</div>
            </div>
            <div class="league flex flex-align-center">
              <div class="logo"><img :src="common.leagueImgGet(item['leagueId'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{relateLeague[item.leagueId]['shortName']}}  {{getGameTime(item.startTime)}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <van-popup class="tipPopup" v-model="tipPopupShow" :position="isWeb?'center':'bottom'" round  get-container="#app">
      <div class="popup_head flex flex-align-center">
        <p class="popup_title">Poisson Prediction Instruction</p>
        <i class="popup_close" @click="tipPopupShow = !tipPopupShow"/>
      </div>
      <div class="popup_body">
        <div>
          <div class="popup_body_title">Poisson predictions based on Poisson distribution for match outcomes.</div>
          <ul>
            <li>
              <div class="list_title">Poisson Predicted Goals：</div>
              <div>
                <p>Based on Poisson distribution, the "Goals" prediction results recommend two total goal counts with the highest probabilities for your reference;</p>
                <p>Each option below shows the calculated probability, as well as the reference odds for your consideration.</p>
              </div>
            </li>
          </ul>
          <div class="img">
            <img v-if="isWeb == true" src="~@/assets/images/goals_poisson_pc.png" />
            <img v-if="isWeb == false" src="~@/assets/images/goals_poisson_mb.png" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import * as echarts from "echarts"

export default {
  name: 'goals',
  props: {
    detailInfo: {
      type: Object,
      default:null
    }, 
    relateMatch: {
      type: Array,
      default:null
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    match: {
      type: Object,
      default:null
    }, 
    setting: {
      type: Object,
      default: () => {}
    },
    relateLeague: {
      type: [Object,Array],
      default:null
    },
  },
  data(){
    return {
      isWeb: true,
      tipPopupShow: false,
      goals_isChecked: false,  //过往交锋进球数走势同主客是否选中
    }
  },
  methods: {
    // 登录传参
    onChangePop(val) {
      let eventName = 'LS_PC_H_Login';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_H_Login';
      }

      this.common.googleEvent(eventName, {
          '触发位置': '比赛内页Goals'
      });

      let _val = val;
      this.$emit('onChangLogin', _val);
    },
    getMatchTime(val,dateForm){
      let _val = val;
      let _tsz = this.setting.tsz;
      var setting=this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let _time = this.common.getDateByArray(_tsz, _val);
      
      return this.common.dateStr(_time, dateForm);
    },

    getGameTime(startTime){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },

    getLineInfo(){
      if(this.detailInfo == null) return
      this.$nextTick(() => {
        let _this = this
        let goalsArr = []
        let timeArr = []
        let arr = this.goals_isChecked == false ? this.detailInfo.goalModel.goalsLastLog : this.detailInfo.goalModel.goalsSameLastLog
        for (let i = 0; i < arr.length; i++) {
          const ele = arr[i];
          goalsArr.push(ele.goals || 0)
          timeArr.push(this.getMatchTime(Math.floor(new Date(ele.time).getTime() / 1000),'YYYY.MM.dd'))
        }
        this.lineEchart = echarts.init(this.$refs.lineEchart);
        this.lineEchart.setOption({
          grid: {
            top: '16%',
            left: this.isWeb == true ? '6%' : '8%',
            right: '0',
            bottom: '21%',
          },  
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(38, 38, 38, 0.5)',
            hideDelay: 800,
            borderWidth: 2,
            borderColor: '#FECD05',
            borderRadius: 5,
            textStyle: { // 提示框浮层的文本样式。
              color: '#fff',
              fontSize: 12,
            },
            padding: [8,14,8,14],
            confine: true,
            formatter: function(arg) {
              return '<div>'+arg[0].axisValueLabel+'</div><div style="font-weight: bold">'+arg[0].data+' goal</div>'
            }
          },
          xAxis: {
            type: 'category',
            data: timeArr,
            axisLine: {
              lineStyle: {
                color: '#D9D9D9' // 设置 x 轴颜色为红色
              }
            },
            axisLabel: {
              show: true,
              rotate: 45,    // 设置x轴标签旋转角度
              color: '#262626',
              fontSize: 12,
              formatter: function(arg) {
                let index = arg .lastIndexOf(".")
                arg = arg .substring(0,index);
                return arg
              },
            },
            axisTick: {
              alignWithLabel: true, // true：标签位于刻度线正下方；false：标签位于2个刻度线中间
            },

          },
          yAxis: {
            type: 'value',
            name: '（Goals）',
            nameLocation: 'end',
            nameTextStyle: { // 设置名称的样式
              color: '#595959',
              padding: [0,0,0,15],
              fontSize: 12,
            }
          },
          series: [
            {
              data: goalsArr,
              type: 'line',
              smooth: true,
              symbolSize: 5,
              itemStyle: {
                color: '#FECD05'    //小圆点和线的颜色
              },
              label: {
                show: true // 显示数据点标签
              },
              symbol: 'circle',
            }
          ]
        });
        this.lineEchart.resize()
      })
    },

    // 同主客
    goalsHomeAndAway(){
      this.goals_isChecked = !this.goals_isChecked
      this.getLineInfo()
    },

    getRadarInfo(){
      if(this.detailInfo == null) return
      this.$nextTick(() => {
        var indicatorArr = []
        var homeArr = []
        var awayArr = []
        var lanArr = ['Goals per game','Corners per game','Shots per game','Goals conceded per game (Home/Away)','Goals conceded \n per game','Goals per game \n (Home/Away)']

        // goals
        if(this.detailInfo.goalModel.avGoals.home.goals && this.detailInfo.goalModel.avGoals.away.goals){
          indicatorArr.push({ name: lanArr[0]+','+this.detailInfo.goalModel.avGoals.home.goals+','+ this.detailInfo.goalModel.avGoals.away.goals })
          homeArr.push(this.detailInfo.goalModel.avGoals.home.goals)
          awayArr.push(this.detailInfo.goalModel.avGoals.away.goals)
        }
        // corners
        if(this.detailInfo.goalModel.avGoals.home.corners && this.detailInfo.goalModel.avGoals.away.corners){
          // indicatorArr.push({ name: lanArr[1]+','+this.detailInfo.goalModel.avGoals.home.corners+','+ this.detailInfo.goalModel.avGoals.away.corners, max: (this.detailInfo.goalModel.avGoals.home.corners + this.detailInfo.goalModel.avGoals.away.corners)})
          indicatorArr.push({ name: lanArr[1]+','+this.detailInfo.goalModel.avGoals.home.corners+','+ this.detailInfo.goalModel.avGoals.away.corners})
          homeArr.push(this.detailInfo.goalModel.avGoals.home.corners)
          awayArr.push(this.detailInfo.goalModel.avGoals.away.corners)
        }
        // shots
        if(this.detailInfo.goalModel.avGoals.home.shots && this.detailInfo.goalModel.avGoals.away.shots){
          // indicatorArr.push({ name: lanArr[2]+','+this.detailInfo.goalModel.avGoals.home.shots+','+ this.detailInfo.goalModel.avGoals.away.shots, max: (this.detailInfo.goalModel.avGoals.home.shots + this.detailInfo.goalModel.avGoals.away.shots)})
          indicatorArr.push({ name: lanArr[2]+','+this.detailInfo.goalModel.avGoals.home.shots+','+ this.detailInfo.goalModel.avGoals.away.shots})
          homeArr.push(this.detailInfo.goalModel.avGoals.home.shots)
          awayArr.push(this.detailInfo.goalModel.avGoals.away.shots)
        }
        // // side_loss
        if(this.detailInfo.goalModel.avGoals.home.sideLoss && this.detailInfo.goalModel.avGoals.away.sideLoss){
          // indicatorArr.push({ name: lanArr[3]+','+this.detailInfo.goalModel.avGoals.home.sideLoss+','+ this.detailInfo.goalModel.avGoals.away.sideLoss, max: (this.detailInfo.goalModel.avGoals.home.sideLoss + this.detailInfo.goalModel.avGoals.away.sideLoss)})
          indicatorArr.push({ name: lanArr[3]+','+this.detailInfo.goalModel.avGoals.home.sideLoss+','+ this.detailInfo.goalModel.avGoals.away.sideLoss})
          homeArr.push(this.detailInfo.goalModel.avGoals.home.sideLoss)
          awayArr.push(this.detailInfo.goalModel.avGoals.away.sideLoss)
        }
        // side_goals
        if(this.detailInfo.goalModel.avGoals.home.sideGoals && this.detailInfo.goalModel.avGoals.away.sideGoals){
          // indicatorArr.push({ name: lanArr[5]+','+this.detailInfo.goalModel.avGoals.home.sideGoals+','+ this.detailInfo.goalModel.avGoals.away.sideGoals, max: (this.detailInfo.goalModel.avGoals.home.sideGoals + this.detailInfo.goalModel.avGoals.away.sideGoals)})
          indicatorArr.push({ name: lanArr[5]+','+this.detailInfo.goalModel.avGoals.home.sideGoals+','+ this.detailInfo.goalModel.avGoals.away.sideGoals})
          homeArr.push(this.detailInfo.goalModel.avGoals.home.sideGoals)
          awayArr.push(this.detailInfo.goalModel.avGoals.away.sideGoals)
        }
        // loss
        if(this.detailInfo.goalModel.avGoals.home.loss && this.detailInfo.goalModel.avGoals.away.loss){
          indicatorArr.push({ name: lanArr[4]+','+this.detailInfo.goalModel.avGoals.home.loss+','+ this.detailInfo.goalModel.avGoals.away.loss})
          homeArr.push(this.detailInfo.goalModel.avGoals.home.loss)
          awayArr.push(this.detailInfo.goalModel.avGoals.away.loss)
        }
        
        this.radarEchart = echarts.init(this.$refs.radarEchart);
        this.radarEchart.setOption({
          color: ['#FF5D71', '#2997FF'],
          radar: {
            radius: this.isWeb == true ? '73%' : '56%',
            center: ['50%', '50%'],
            name: {
            
              formatter: (str) => {
                // if(str.indexOf(lanArr[0]) != -1){
                //   return ['{a|'+str.split(',')[1]+'}{b|/}{c|'+str.split(',')[2]+'}','{e|""}','{d|'+str.split(',')[0]+'}'].join('\n');
                // }else{
                //   return ['{d|'+str.split(',')[0]+'}','{e|""}','{a|'+str.split(',')[1]+'}{b|/}{c|'+str.split(',')[2]+'}'].join('\n');
                // }
                return ['{d|'+str.split(',')[0]+'}','{e|""}','{a|'+str.split(',')[1]+'}{b|/}{c|'+str.split(',')[2]+'}'].join('\n');
              },
              rich: {
                a: {
                  color: '#FF5D71',
                  align: 'center'
                  // fontSize: Math.ceil(FontSize*(10/12)),
                  // fontFamily: "PingFang-SC",
                },
                b: {
                  color: '#000',
                  align: 'center'
                  // fontSize: Math.ceil(FontSize*(10/12)),
                  // fontFamily: "PingFang-SC",
                },
                c: {
                  color: '#2997FF',
                  align: 'center'
                  // fontSize: Math.ceil(FontSize*(10/12)),
                  // fontFamily: "PingFang-SC",
                },
                d: {
                  color: '#000',
                  align: 'center'
                  // fontSize: Math.ceil(FontSize*(10/12)),
                  // fontFamily: "PingFang-SC",
                },
                e:{
                  lineHeight: 3,
                  color: 'transparent'
                }
              }
            },
            indicator: indicatorArr,
            splitLine: {
              show: true,
              // lineStyle: {
              //   type: "dashed",
              // }
            },
            axisLine: { //射线的样式
              lineStyle:{
                color: "#F1F2F3",//射线的颜色
              },
            },
            splitNumber: 5, 
            splitArea:{		
              areaStyle:{
                color:['#eeeeee','#dddddd','#fafafa','#fafafa','#d9d9d9'],  //背景颜色,
              }
            },
            nameGap: 5
          },
          
          series: [
          {
            name: 'Budget vs spending',
            type: 'radar',
            symbolSize: 0, //设置圆环内各个数据的圆点大小
            data: [
              {
                value: homeArr,
                name: '1',
                lineStyle: {
                  width: 2
                }
              },
              {
                value: awayArr,
                name: '2',
                lineStyle: {
                  width: 2
                }
              }
            ],
          }
          ]
        });
        this.radarEchart.resize();
      })
    },

    // 判断是否命中
    isHit(isHit){
      if(this.match.state == 4){
        if(isHit == 1){
          return 'hit'
        }else{
          return 'noHit'
        }
      }
    },

    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
      }
    },

    // 关联比赛
    changeMatch(item){
      let eventName = 'LS_PC_MD_AdditionalMatches_Click';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_MD_AdditionalMatches_Click';
      }
      this.common.googleEvent(eventName, {
        '玩法': this.langConfig.txtLang[this.langConfig.curLang]['PLAY_EVENT'][4]
      });

      let _homeName = this.common.formalTitle(item.homeTeam.fullName)
      let _awayName = this.common.formalTitle(item.awayTeam.fullName)
      if(this.$route.params.id != item.matchId) this.$router.push("/details/" +  this.$route.params.tab + '/' + item.matchId + '/' + _homeName + '-vs-' + _awayName);
    },

    showPopup(){
      if(!this.tipPopupShow){
        let eventName = 'LS_PC_Help_Click';
        if(this.common.isMobile != 4){
            eventName = 'LS_Webapp_Help_Click';
        }

        this.common.googleEvent(eventName, {
            '点击位置': '比赛内页Goals'
        });
      }

      this.tipPopupShow = true
    },
  },
  mounted() {
    let eventName = 'LS_PC_MD_Goals';
    if(this.common.isMobile != 4){
        eventName = 'LS_Webapp_MD_Goals';
    }
    this.common.googleEvent(eventName);

    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  watch:{
    isLogin:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val == true){
          this.getLineInfo()
          this.getRadarInfo()
        }
      }
    },
    match:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val.state == 4){
          this.getLineInfo()
          this.getRadarInfo()
        }
      }
    },
    detailInfo: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.isLogin == true || this.match.state == 4){
          this.getLineInfo()
          this.getRadarInfo()
        }
      }
    },
    isWeb:{
      immediate: true,
      deep: true,
      handler(val) {
        this.getRadarInfo()
      }
    },
  }
}
</script>
<style scoped lang="less"> 
  @import 'goals.less';  
</style>


// WEBPACK FOOTER //
// ./src/views/details/components/goals.vue